import { useRoutes } from 'react-router-dom'
import { permissionAuth } from '@/utils/permission'
import routesConfig from './routes'

export const filterRoutes = (routes: any[], isSuper: boolean) => {
  if (!routes) return []
  return routes.filter((route) => {
    if (route.children) {
      route.children = filterRoutes(route.children, isSuper)
    }
    // if (route.super && !isSuper) return false
    return (permissionAuth(route.key) && route.auth) || !route.auth
  })
}

const MainRoutes = () => {
  const { privateRoutes, publicRoutes } = routesConfig
  const authPrivateRoutes = filterRoutes(privateRoutes(), true)

  const element = useRoutes([...authPrivateRoutes, ...publicRoutes])
  return element
}

export default MainRoutes
